module.exports = __webpack_public_path__ + "static/media/piso-superior-risco.c0b06cc8.jpg";